import type { MediaContract } from '@tamtamy/paperbits-common/src/media/mediaContract';
import type { EntityRendition } from '../dam-api-client/DiscoveryDAMApiTypes';

export interface TransformOptions {
    aspectRatio?: AspectRatio;
    width?: number;
    height?: number;
    rendition?: EntityRendition
}

export enum AspectRatio {
    SixteenByNine = '16/9',
    TwoByThree = '2/3',
    OneByOne = '1/1',
    Unset = 'unset',
}

export function toRatio(ratio: AspectRatio): [number, number] {
    let w: number;
    let h: number;
    switch (ratio) {
        case AspectRatio.SixteenByNine:
            w = 16;
            h = 9;
            break;
        case AspectRatio.TwoByThree:
            w = 2;
            h = 3;
            break;
        case AspectRatio.OneByOne:
            w = 1;
            h = 1;
            break;
    }
    return [w, h];
}

export function imQuery(contract: MediaContract, options: TransformOptions): string {
    const transforms: string[] = [];
    if (options?.aspectRatio && options?.aspectRatio !== AspectRatio.Unset) {
        const crop = contract.crops?.[options.aspectRatio];
        if (crop) {
            transforms.push(`Crop,rect=(${crop.x},${crop.y},${crop.width},${crop.height}),allowExpansion`);
        } else {
            const [h, w] = toRatio(options.aspectRatio);
            transforms.push(`AspectCrop=(${h},${w})`);
        }
    }
    if (options?.width || options?.height) {
        const resize: string[] = ['Resize'];
        if (options.width) {
            resize.push(`width=${options.width}`);
        }
        if (options.height) {
            resize.push(`height=${options.height}`);
        }
        transforms.push(resize.join(','));
    }
    return transforms.length ? `?im=${transforms.join(';')}` : '';
}

export type AspectRatioMap =  { [key in Exclude<AspectRatio, AspectRatio.Unset>]: string };

export function emptyAspectRatioMap(): AspectRatioMap {
    return {
        [AspectRatio.OneByOne]: undefined,
        [AspectRatio.SixteenByNine]: undefined,
        [AspectRatio.TwoByThree]: undefined,
        // [AspectRatio.Unset]: undefined Excluded since it was omitted before
    };
}